import { ISocketService } from '../ports/socket-service.port'
import { useSocket } from '../infrastructure/script/socket/socket-post-message'

const socketService = useSocket()
export const useSocketServiceAdapter = (): ISocketService => {
	return socketService
}
